import styled from "styled-components"

export const RecentMealsWrapper = styled.div`
  border-radius: var(--spacing_s, 8px);
  border: 1px solid
    var(--Schemes-Outline-Outline-Variant, rgba(0, 38, 58, 0.14));
  background: #fbfbfb;

  padding: var(--spacing_s, 8px) var(--spacing_m, 12px);

  max-height: 500px;
  overflow: auto;
  width: 100%;
`

